import {moment} from 'external/moment'
import {clsx} from 'external/clsx'
import {FC, Form} from 'external/react'

type FromToProps = {
    className?: string
    start: string | Date
    end: string | Date
    onChange: (source: 'start' | 'end', date: string) => void
    startProps?: any
    endProps?: any
}

const FromTo: FC<FromToProps> = props => {
    const {className, start, end, onChange, startProps = {}, endProps = {}} = props
    return (
        <span className={clsx('from-to-date', className)}>
            <span className="from-to-date-start">
                <Form.Label>Fecha de comienzo</Form.Label>
                <Form.Control type='date' min={new Date()} value={moment(start).format('YYYY-MM-DD')} onChange={(e) => onChange('start', e.target.value)} {...startProps} />
            </span>
            <span className="from-to-date-end">
                <Form.Label>Fecha de culminación</Form.Label>
                <Form.Control type='date' min={new Date()} value={moment(end).format('YYYY-MM-DD')} onChange={(e) => onChange('end', e.target.value)} {...endProps} />
            </span>
        </span>
    )
}

export {FromTo as default}